/* Osner Art Gallery: approximate local price beneath every US dollar price.
   Prices on the page stay in dollars. The visitor's currency and the rate come from the BUCKS converter app,
   read from a hidden probe it converts. If BUCKS is missing, or the visitor uses dollars, the line stays empty. */
(function () {
  var WORD = (window.osnerStrings && window.osnerStrings.approx) || 'approx.';
  function currency() {
    var p = document.querySelector('.o-probe [bucks-currency], .o-probe[bucks-currency]');
    var c = p && p.getAttribute('bucks-currency');
    return c && c !== 'USD' ? c : null;
  }
  function round(v) { return v >= 1000 ? Math.round(v / 100) * 100 : v >= 100 ? Math.round(v / 10) * 10 : Math.round(v); }
  function fmt(v, c) {
    try {
      var loc = c === 'ZAR' ? 'en-ZA' : c === 'EUR' ? 'de-DE' : c === 'GBP' ? 'en-GB' : c === 'AUD' ? 'en-AU' : undefined;
      return new Intl.NumberFormat(loc, { style: 'currency', currency: c, maximumFractionDigits: 0 }).format(v);
    } catch (e) { return c + ' ' + v; }
  }
  function fill() {
    var c = currency();
    var B = window.bucksCC && window.bucksCC.Currency;
    document.querySelectorAll('[data-o-approx]').forEach(function (el) {
      var usd = parseFloat(el.getAttribute('data-usd'));
      var out = '';
      if (c && B && B.convert && usd) { var v = B.convert(usd, 'USD', c); if (isFinite(v) && v > 0) out = WORD + ' ' + fmt(round(v), c); }
      if (el.textContent !== out) el.textContent = out;
    });
  }
  window.osnerApprox = fill;
  document.addEventListener('osner:approx', fill);
  document.addEventListener('DOMContentLoaded', fill);
  var n = 0, t = setInterval(function () { fill(); if (++n > 20 || currency()) { fill(); clearInterval(t); } }, 300);
  var queued = false;
  function later() { if (queued) return; queued = true; setTimeout(function () { queued = false; fill(); }, 150); }
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      var tg = m[i].target;
      if (tg.nodeType !== 1 || tg.hasAttribute('data-o-approx')) continue;
      if (tg.closest('.o-probe') || tg.id === 'product-grid' || tg.closest('cart-drawer, cart-items, #main-cart-footer, .o-rel-reco')) { later(); return; }
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['bucks-currency'] });
})();
